import { Component, OnInit } from '@angular/core';
import { LoudnessPerceptionService } from 'src/app/service/loudnessPerception.service';
import { Router, Event, NavigationStart } from '@angular/router';
import { LoadingDialog } from '../dialogs/loading/loading.dialog';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { TaskService } from 'src/app/service/tasks.service';


@Component({
  selector: 'app-loudness-perception',
  templateUrl: './loudness-perception.component.html',
  styleUrls: ['./loudness-perception.component.css']
})
export class LoudnessPerceptionComponent implements OnInit {
  ready = true;
  started = false
  audio;
  rated = 0
  initTimeStamp;
  showEval = false;
  rates = []
  second = 0
  response = false
  done = false
  charged = false
  charged2 = false
  configured = false
  sTest = false
  hideConf = false
  playSample = false
  samplePlayed = false
  audioSource: string
  testFinished = false
  timeOutRef
  speakersInstructions = false;
  showLabel = false


  constructor(
    private router: Router,
    private loudnessPerceptionService: LoudnessPerceptionService,
    private dialog: MatDialog,
    public translate: TranslateService,
    private taskService: TaskService
  ) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.audio.pause()
        this.audio.src = '';
        this.audio.load();
      }
    })
  }

  ngOnInit() {
    this.initAudio("loudnessPerception")
    this.loudnessPerceptionService.check_exp()
      .then(data => {
        this.done = data.body.valid
        this.charged = true
        this.charged2 = true
      })
  }

  showRating() {
    //this.rated += 1
    this.showEval = true

    //make buttons flash to get attention
    this.timeOutRef = setTimeout(() => {
      this.showEval = false
      this.timeOutRef = setTimeout(() => {
        this.showEval = true
      }, 150)
    }, 150)

    //stop getting answers after 10 seconds
    this.timeOutRef = setTimeout(() => {
      if (this.showEval) {
        this.showEval = false
        this.rateInstant(null)
      }
    }, 10000)
    if (this.rated < 9) 
      this.timeOutRef = setTimeout(() => this.showRating(), 20000)
  }

  rateInstant(rate) {
    this.rates.push({ order: this.rated, rate: rate })
    this.showEval = false
    this.rated++
    if (this.rated === 9) 
      this.submit()
    console.log(this.rates)
  }
  submit() {
    console.log("CHIAMATA A SUBMIT")
    this.audio.pause()
    clearTimeout(this.timeOutRef)
    const data = this.rates.map(r => {
      r.audioSource = this.audioSource
      return r
    })

    const dialogRef = this.dialog.open(LoadingDialog, { disableClose: true })

    this.loudnessPerceptionService.save(data).then(resp => {
      dialogRef.close()
      
      if (resp.status === 200) {
        this.testFinished = true
        setTimeout(() => {
          this.router.navigate([''])
        }, 3000)
      }
    })
    .then(() => {
      this.taskService.saveCompletedTask({ "type": "LoudnessPerception" })
    })
    .catch(e => {
      console.log(e);
    });
  }

  timeStampAux() {
    const date = new Date()
    let dateAux = date.toISOString()
    dateAux = dateAux.replace("T", " ")
    dateAux = dateAux.replace("Z", "")
    return dateAux;
  }

  clock() {

    if (this.second <= 190)
    this.timeOutRef = setTimeout(() => {
        this.second += 1
        if(this.second == 10)
          this.showLabel = false
        this.clock()
      }, 1000)
    else this.audio.pause()
  }

  playSound() {
    this.audio.play();
    this.initTimeStamp = this.timeStampAux()
    this.clock()
    this.timeOutRef = setTimeout(() => {
      this.showRating()
    }, 10000)
  }

  start1() {
    this.audioSource === 'speakers' ? (this.speakersInstructions = true) : (this.speakersInstructions = false)
    this.started = true
  }

  next(){
    this.speakersInstructions = false
  }

  start2() {
    this.hideConf = true
    this.timeOutRef = setTimeout(() => { this.configureVol() }, 1000)
  }
  start3() {
    this.sTest = true
    this.showLabel = true
    this.initAudio("loudnessPerception")
    this.timeOutRef = setTimeout(() => { this.playSound() }, 1000)
  }
  start4() {
    this.playSample = true
    this.timeOutRef = setTimeout(() => { this.sampleSound() }, 1000)
  }
  sampleSound() {
    this.audio.play();
    this.timeOutRef = setTimeout(() => {
      this.audio.pause()
      this.samplePlayed = true
    }, 5000)
  }
  configureVol() {
    this.audio.play();
    this.timeOutRef = setTimeout(() => {
      this.audio.pause()
      this.configured = true
      this.samplePlayed = true
    }, 10000)
  }

  initAudio(audio) {
    let aud = new Audio();
    aud.src = '../../assets/' + audio + '.wav';
    aud.load();
    this.audio = aud
    return
  }

  setAudioType(type: string) {
    this.audioSource = type
  }

}
